import { ApiClient } from "./api.js";
import { initAuth } from "./auth.js";
import { loadConfig } from "./config.js";
import "./app.js";
import type { NfApp } from "./app.js";

async function bootstrap(): Promise<void> {
  const app = document.querySelector<NfApp>("nf-app");
  if (!app) throw new Error("<nf-app> host element missing");

  try {
    const config = await loadConfig();
    const auth = await initAuth(config);
    const api = new ApiClient({
      apiBase: config.apiBase,
      getToken: () => auth.getToken(),
    });
    app.config = config;
    app.auth = auth;
    app.api = api;
    app.ready = true;
  } catch (err) {
    app.bootError = err instanceof Error ? err.message : String(err);
  }
}

void bootstrap();
